<input [(ngModel)]="element._value" type="number" [readonly]="element._get('readOnly')">
